<template>
  <div class="content-box">
	  <HconTitle subTitle="주문서 임시저장" />
    <div class="sub-wrapper block">
      <div class="border-title check">
        <div class="lft-txt">
          <HconCheckBox type="checkTitle" label="선택" :num="selectedCount" name="allCheckBtn" labelClass="top-check-title" :hide-label="false" v-model:checked="toggleAll" />
          <span class="txt" v-if="orderSheets.length > 0">*주문서는 14일 이후 자동으로 삭제됩니다.</span>
          <span class="txt" v-else></span>
        </div>
        <p class="rgt-txt">
          <span class="total">총 <em class="count">{{orderSheets.length}}</em>건</span>
          <span class="text-gray">(최대 <span class="count">20</span>건)</span>
        </p>
      </div>
      <div class="sheet-container">
        <template v-if="orderSheets.length > 0">
          <div class="sheet-wrapper">
            <ul class="sheet-list">
              <HconTempOrderSave v-for="sheet in orderSheets" :key="sheet.ordNo" :data="sheet" v-model:isChecked="sheet.selected"
                                 @deleteSheet="removeTmpSave" @placeOrder="linkToOrder" />
            </ul>
          </div>
          <div class="button-box mt20 jc-l">
            <button type="button" class="btn btn-outline" @click="removeTmpSaveList">선택 삭제</button>
          </div>
        </template>
        <div v-else class="no-data mt120 pb60">
          <img src="@/assets/images/pc/icon-hcon/icon-temp-save-gray.svg" alt="" width="46px" height="40px" />
          <p>임시저장 된 주문정보가 없습니다.</p>
        </div>
      </div>      
      <div class="box-gray inset40 mt80">
        <h4 class="title">주문서 임시저장 안내</h4>
        <ul class="dot-list mt24">
          <li>주문서 임시저장에는 최대 20개 임시저장을 담을 수 있습니다.</li>
          <li>담아둔 상품의 재고가 없거나 품절되면 잠시 구매가 제한될 수 있습니다.</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconTempOrderSave from '@/components/corner/pc/HconCornerOrderTempSavePC.vue'
import { usePopup } from '@/composables/hconUsePopup'
import { useRoute, useRouter } from 'vue-router';
import { reactive, onMounted, computed } from 'vue'
import { COMMON_CODE, ORDER_CODE } from "@/constants/hconMessageConstants";
// 페이지 전체 로딩
import type { Loadingstatus } from '@/layouts/default.vue'
// DTO 준비
import type { TmpSaveOrdDto, TmpSaveGdsDto } from '@/types/order/backend-dto-types';

definePageMeta({label:'주문서 임시저장'})

// 팝업 준비
const { showAlert, showConfirm } = usePopup()
const route = useRoute()
const router = useRouter()
// API 호출 준비
const fetchBuilder  = useHconFetchBuilder();
// 페이지 전체 로딩
const loadingStatus = useState<Loadingstatus>('loading-status')
const { refreshCnt } = useHeader()

// 화면 마운트, 목록조회 즉시 실행
onMounted(() => {getTmpSaveList()});

// 임시저장 주문서 목록 매핑대상 준비
const orderSheets = reactive<any[]>([])
// 임시저장 주문서 목록 조회
const getTmpSaveList = async () => {
  const fetchBuilderResult = 
  fetchBuilder.get<AjaxResult<TmpSaveOrdDto[]>>('/api/v1/order/temp-save')
  .progressMessage("잠시만 기다려주세요...")
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode != '200') {
      showAlert(result.resultMessage);
    } else {
      orderSheets.splice(0,orderSheets.length, ...result.data);
    }        
  })
}

// 전체선택 체크박스 반응형 구현
const selectedCount = computed(() => {
  return orderSheets.filter(sheet => sheet.selected).length;
});
const toggleAll = computed({
  get: () => {
    return orderSheets.length > 0 && orderSheets.every(sheet => sheet.selected);
  },
  set: (newValue) => {
    orderSheets.forEach(sheet => {
      sheet.selected = newValue;
    })
  }
});

// 임시저장 주문서 단건 삭제(논리삭제)
const removeTmpSave = async (item: any) => {
  // 컨펌 팝업
  const confirmResult = showOrderRemoveConfirm();
  if( await confirmResult) {
    // 파라미터 확인
    const ordNoList = [item];
    // API 호출
    const fetchBuilderResult = 
    fetchBuilder.post<AjaxResult<Number>>('/api/v1/order/temp-save/list')
    .body(ordNoList)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        // 성공시 화면에서 단건 삭제
        const targetIndex = orderSheets.findIndex(sheet => sheet.ordNo === item);
        if(targetIndex > -1) {
          orderSheets.splice(targetIndex, 1);
        }

        const delCnt = result.data;
        refreshCnt();
        console.log(delCnt+' 건이 삭제되었습니다.');
      }        
    })
  }
}
// 임시저장 주문서 다건 삭제(논리삭제)
const removeTmpSaveList = async () => {  
  // 파라미터 확인
  const ordNoList = orderSheets
      .filter(sheet => sheet.selected)
      .map(sheet => sheet.ordNo);

  if(ordNoList.length != 0) {
    // 컨펌 팝업
    const confirmResult = showOrderRemoveConfirm();
    if(await confirmResult) {
      // API 호출
      const fetchBuilderResult = 
      fetchBuilder.post<AjaxResult<Number>>('/api/v1/order/temp-save/list')
      .body(ordNoList)
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((result) => {
        if(result.resultCode != '200') {
          showAlert(result.resultMessage);
        } else {
          // 성공시, 선택되지 않은 배열들로 화면 다시 그리기
          const remainingSheets = orderSheets.filter(sheet => !sheet.selected);
          orderSheets.splice(0, orderSheets.length, ... remainingSheets);

          const delCnt = result.data;
          refreshCnt();
          console.log(delCnt+' 건이 삭제되었습니다.');
        }        
      })
    }
  } else {
      showAlert('삭제하실 주문서 임시저장을 선택해주세요.');
  }
}
// 임시저장 주문서 삭제 전 컨펌 팝업
const showOrderRemoveConfirm = async() => {
  const result = await showConfirm({
    title: '주문서 임시저장 삭제',
    message: ORDER_CODE.ALT_HCON_9119, // '선택하신 주문서 임시저장을 삭제하시겠습니까?'    
    confirmText: '확인',
    cancelText: '취소',
  })
  return result;
}

// 주문하기로 이동
const linkToOrder = async (targetSheet: any) => {
  // 안내사항 팝업
  if (targetSheet.buyNdmtGdsInclYn == 'Y') { // 구매불가상품포함여부
    // 모든 상품 구매 불가
    const isAllBuyNdmt = targetSheet.gdsList.every((item: TmpSaveGdsDto) => item.buyPossYn === 'N'); 
    if(isAllBuyNdmt) {
      showAlert({title: '구매 불가 상품 제외',
                 message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9164, '구매가능한','상품이')}); // {구매가능한} {상품이} 없습니다.
      return;
    }
    const resultConfirm = await showBuyNdmtGdsInclConfirm();
    if (!resultConfirm) return;
  }
  if (targetSheet.cshabGdsInclYn == 'Y') { // 환금성상품포함여부
    // [26.04.15 추가] 영업일 09:00~18:00 외 주문불가
    const response = await fetchBuilder.get<AjaxResult<any>>('/api/v1/order/check-trading-time')
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()

    if(response.resultCode != '200') { // 오류
      showAlert(response.resultMessage)
      return;
    } else {
      if(response.data.message === 'SUCESS') { // 주문 가능
        const resultConfirm = await showCshabGdsInclConfirm();
        if (resultConfirm !== true) return; // etc가 있는 경우
      } else { // 주문 불가
        showAlert(ORDER_CODE.ALT_HCON_9218)
        return;
      }
    }
  }
  // 임시저장주문번호 들고 페이지 이동
  loadingStatus.value.full = true
  router.push({
    path: '/pc/order/application-form',
    state: {
      prevPage: 'D',
      originalUrl: route.fullPath,
      tmpSaveOrdNo: targetSheet.ordNo || ''
    }
  })
}
// 구매불가상품포함 시, 제외안내 팝업
const showBuyNdmtGdsInclConfirm = async () => {
  // 취소버튼은 숨기지만, 우상단X 누를 경우 주문서로 이동하지 않게 하기 위하여 confirm창으로 구현하였음.
  const result = await showConfirm({
    title: '구매 불가 상품 제외',
    message: ORDER_CODE.ALT_HCON_9070, // '선택하신 주문서에서 <span class="text-green">구매불가한 상품은 제외 후</span> 주문 페이지로 이동합니다.'
    showCancelButton: false
  })
  return result;
}
// 환금성상품포함 시, 확인안내 팝업
const showCshabGdsInclConfirm = async () => {
  const result = await showConfirm({
    title: '구매 전 확인사항',
    message: ORDER_CODE.ALT_HCON_9120, // '구매 상품에 환금성(상품권, 금액권 등) 상품 포함 시 <span class="text-green">관리자 승인 후 1영업일 이내 일괄 발송</span>됩니다.<br/>관련 문의사항은 1:1 문의 부탁드립니다.'
    confirmText: '확인완료',
    etcText: '1:1 문의',
    showEtcButton: true,
    showCancelButton: false,
    onEtc: () => {
      router.push('/pc/inquiry/list')
    }
  })
  return result;
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
</style>